import { gql } from '../../__generated__';

export default gql(`
  query getCustomerDiagnosticResults {
    customer {
      diagnostic_results {
        uid
        created_at
        product_list
      }
    }
  }
`);
